import { useCallback, useEffect, useRef, useState } from "react";

const MOBILE_MQ = "(max-width: 1320px)";

export function useBurgerMenu(pageSelector = ".wb-page") {
  const [open, setOpen] = useState(false);
  const pageRef = useRef<Element | null>(null);

  useEffect(() => {
    pageRef.current = document.querySelector(pageSelector);
  }, [pageSelector]);

  const close = useCallback(() => {
    setOpen(false);
    document.body.style.overflow = "";
  }, []);

  const toggle = useCallback(() => {
    if (!window.matchMedia(MOBILE_MQ).matches) return;
    setOpen((v) => {
      const next = !v;
      document.body.style.overflow = next ? "hidden" : "";
      return next;
    });
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") close();
    };
    const onResize = () => {
      if (!window.matchMedia(MOBILE_MQ).matches) close();
    };
    window.addEventListener("keydown", onKey);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("resize", onResize);
    };
  }, [open, close]);

  useEffect(() => () => close(), [close]);

  return { open, toggle, close };
}
